import { go, mapL } from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { VONS } from "../../VO/VONS.js";
export class ArtBoard {
  constructor({ svg_el, getCTM, width, height }) {
    this._observer_set = new Set();
    this._svg_el = svg_el;
    this._getCTM = getCTM;
    this._width = width;
    this._height = height;
  }
  subscribe(observer) {
    if (this._observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer({
      width: this._width,
      height: this._height,
    });
    this._observer_set.add(observer);
    return () => {
      this._observer_set.delete(observer);
    };
  }
  getWidth() {
    return this._width;
  }
  getHeight() {
    return this._height;
  }
  resize({ width, height }) {
    if (width < 0) {
      throw new Error(`art_board 의 width 는 음수일 수 없습니다.`);
    }
    if (height < 0) {
      throw new Error(`art_board 의 height 는 음수일 수 없습니다.`);
    }
    this._width = width;
    this._height = height;
    this._notify({
      width: this._width,
      height: this._height,
    });
  }
  getBBoxInViewPort(padding = 0) {
    const ctm = this._getCTM();
    const { min_x, min_y, max_x, max_y } = go(
      [
        [padding, padding],
        [this._width - padding, this._height - padding],
      ],
      mapL(CommonNS.UtilNS.createSVGPoint(this._svg_el)),
      mapL((point) => point.matrixTransform(ctm)),
      CommonNS.UtilNS.calculateMinMaxXY
    );
    return {
      x: min_x,
      y: min_y,
      width: max_x - min_x,
      height: max_y - min_y,
    };
  }
  _notify(art_board_vo) {
    for (const observer of this._observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(art_board_vo));
    }
  }
}
